import { render, staticRenderFns } from "./LocationIspPackages.vue?vue&type=template&id=6ef97776&"
import script from "./LocationIspPackages.vue?vue&type=script&lang=js&"
export * from "./LocationIspPackages.vue?vue&type=script&lang=js&"
import style0 from "./LocationIspPackages.vue?vue&type=style&index=0&id=6ef97776&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports